<template>
  <v-layout
    class="rights"
    row
    wrap
    style="flex: 1 0; overflow: auto; align-items: flex-start"
    v-if="missionPlanUiState"
  >
    <v-flex class="px-1 xs12" style="flex-direction: column; align-items: stretch; height: 100%; position: relative">
      <v-card class="mt-1 mb-2 ml-1 mr-2 maincontent card--flex-toolbar">
        <slot></slot>
        <v-toolbar card>
          <div class="flex items-center gap-1" style="width: 100%; font-weight: bold; overflow: auto">
            <div class="!flex flex-col">
              <div>
                <v-btn :disabled="isStepTabVisible" icon @click="showStepTab()">
                  <v-icon :class="isStepTabVisible ? 'text-primary' : ''">mdi-chart-timeline-variant</v-icon>
                </v-btn>
                <span class="selectedTab" v-if="isStepTabVisible">
                  {{ $t('Admin.MissionPlanTemplate.Form.StepList') }}
                </span>
              </div>
              <div v-if="isStepTabVisible" class="absolute bottom-1 font-normal text-primary caption">
                {{ distanceTotal }}
              </div>
            </div>
            |
            <v-btn :disabled="isWaipointTabVisible" icon @click="showWaipointTab()">
              <v-icon>mdi-map-marker</v-icon>
            </v-btn>
            <span class="selectedTab" v-if="isWaipointTabVisible">
              {{ $t('Admin.MissionPlanTemplate.Form.WayPoint') }}
            </span>
            |
            <v-btn :disabled="isProfileTabVisible" icon @click="showProfileTab()"><v-icon>mdi-gauge</v-icon></v-btn>
            <span class="selectedTab" v-if="isProfileTabVisible">
              {{ $t('Admin.MissionPlanTemplate.Form.Profiles') }}
            </span>
            <template v-if="enablePayload">
              |
              <!--Désactivation du bouton de la payload-->
              <!-- <v-btn :disabled="isSensorsTabVisible" icon @click="showSensorsTab()" ><v-icon>mdi-leak</v-icon></v-btn> <span class="selectedTab" v-if="isSensorsTabVisible">{{$t('Admin.MissionPlanTemplate.Form.Payload')}}</span>
              | -->
              <v-btn :disabled="isProfileSciTabVisible" icon @click="showProfileSciTab()">
                <v-icon>mdi-chart-box-outline</v-icon>
              </v-btn>
              <span class="selectedTab" v-if="isProfileSciTabVisible">
                {{ $t('Admin.MissionPlanTemplate.Form.ProfilesSci') }}
              </span>
            </template>
            <v-spacer />
            <v-select
              v-if="isStepTabVisible && !readonly"
              style="min-width: 100px"
              v-model="missionPlan.cur_step"
              :items="stepItems"
              item-text="label"
              item-value="value"
              :label="$t('Admin.MissionPlanTemplate.Form.CurrentStep')"
            ></v-select>
            <v-btn v-if="isStepTabVisible && !hideAutoScale" icon small @click="bestFit()">
              <v-icon>mdi-target</v-icon>
            </v-btn>
            <v-btn v-if="!readonly && isWaipointTabVisible" icon small @click="showGlobalWaypoint()">
              <v-icon>mdi-map-marker-plus</v-icon>
            </v-btn>
            <v-btn v-if="!readonly && isProfileTabVisible" icon small @click="editProfil(-1)">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
            <!-- <v-btn v-if="isSensorsTabVisible" icon small @click="editSensor(-1)"><v-icon>mdi-plus</v-icon></v-btn>                                       -->
            <v-btn v-if="!readonly && isProfileSciTabVisible" icon small @click="editProfilSci(-1)">
              <v-icon>mdi-chart-box-plus-outline</v-icon>
            </v-btn>
          </div>
        </v-toolbar>
        <v-card-title
          class="pb-0 pt-0 pl-0 pr-0"
          v-if="isStepTabVisible"
          :style="{ height: `calc(100% - ${hasSlotData ? '128' : '64'}px)` }"
          style="flex-direction: column; align-items: stretch"
        >
          <v-layout row wrap style="flex: 1 0; overflow: auto; align-items: flex-start">
            <div ref="liste" class="liste steps w-full" @mousemove="checkStepHover" @mouseleave="hoverStepId = -1">
              <draggable
                class="w-full"
                handle=".handle"
                v-model="missionPlan.steps"
                ghost-class="ghost"
                @change="onMove"
              >
                <div
                  class="line-item w-full"
                  :id="step.id"
                  :class="{ hover: hoverStepId == step.id, current: missionPlan.cur_step == step.id }"
                  v-for="(step, index) in missionPlan.steps"
                  :key="step.id"
                >
                  <div class="heading items-center flex ml-2" style="position: relative">
                    <v-btn v-if="!readonly" class="handle grow-0" right icon small>
                      <v-icon>mdi-cursor-move</v-icon>
                    </v-btn>
                    <div
                      class="flex flex-col grow"
                      :style="
                        readonly
                          ? { position: 'relative', maxWidth: '100%' }
                          : { position: 'relative', maxWidth: 'calc(100% - 80px)' }
                      "
                    >
                      <div class="flex items-end pr-4" style="gap: 25px">
                        <span class="grow">
                          {{ index + 1 }} - Go to {{ formatWaypoint(wptsById[step.wpt_id]) }}
                          <!-- - next id : {{step.nextStep_id}}-->
                        </span>
                        <number-field-factor
                          :disabled="readonly"
                          style="max-width: 70px"
                          class="grow-0"
                          hide-details
                          :factor="1000"
                          width="50"
                          :label="$t('Admin.MissionPlanTemplate.Form.RVal')"
                          :title="$t('Admin.MissionPlanTemplate.Form.RValTooltip')"
                          v-model.number="step.rVal"
                        />
                        <number-field-factor
                          :disabled="readonly"
                          style="max-width: 70px"
                          class="grow-0"
                          hide-details
                          width="50"
                          :label="$t('Admin.MissionPlanTemplate.Form.TVal')"
                          :title="$t('Admin.MissionPlanTemplate.Form.TValTooltip')"
                          v-model.number="step.tVal"
                        />
                        <v-switch
                          :disabled="readonly"
                          style="max-width: 100px"
                          class="grow-0"
                          v-if="enablePayload"
                          hide-details
                          v-model="step.payload_enable"
                          :label="$t('Simulation.Payload')"
                        ></v-switch>
                      </div>
                      <div class="d-flex gap-2">
                        <div class="flex flex-col gap-1 w-full">
                          <v-select
                            :disabled="readonly"
                            style="max-width: 250px"
                            class="grow-0 mr-4"
                            v-model="step.prfNav_id"
                            :items="missionPlan.prf_nav"
                            :item-text="formatProfilNav"
                            item-value="id"
                            hide-details
                            :label="$t('Admin.MissionPlanTemplate.Form.Profil')"
                          ></v-select>
                          <div class="profilInfos grow">{{ displayProfilNav(prf_navById[step.prfNav_id], true) }}</div>
                        </div>
                        <!-- <div class="grow-0" style="border-right:1px solid #666;"></div>                    -->
                        <div v-if="step.payload_enable && enablePayload" class="flex flex-col gap-1 w-full">
                          <v-select
                            :disabled="readonly"
                            style="max-width: 250px"
                            class="grow-0 mr-4"
                            v-model="step.prfSci_id"
                            :items="missionPlan.prf_sci"
                            :item-text="formatProfilSci"
                            item-value="id"
                            hide-details
                            :label="$t('Admin.MissionPlanTemplate.Form.ProfilSci')"
                          ></v-select>
                          <div class="profilInfos grow">{{ displayProfilSci(prf_sciById[step.prfSci_id], true) }}</div>
                        </div>
                      </div>
                    </div>
                    <!--<strong><small>(id:{{step.id}})</small></strong>-->
                    <!--<v-btn icon small @click="editStep(step.id)"><v-icon>mdi-cog</v-icon></v-btn>-->
                    <v-btn v-if="!readonly" class="grow-0" icon small @click="deleteStep(step)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </div>
              </draggable>
            </div>
          </v-layout>
          <v-layout row wrap style="flex: 0 0; align-items: flex-start" class="backStep px-2">
            <v-select
              :readonly="readonly"
              v-model="lastActionId"
              :items="lastactions"
              item-text="label"
              item-value="value"
              :label="$t('Admin.MissionPlanTemplate.Form.LastAction')"
              @change="updateNextStep"
            ></v-select>
          </v-layout>
        </v-card-title>
        <v-card-title
          v-if="isWaipointTabVisible"
          :style="{ height: `calc(100% - ${hasSlotData ? '128' : '64'}px)` }"
          style="flex-direction: column; align-items: stretch"
        >
          <v-layout row wrap style="flex: 1 0; overflow: auto; align-items: flex-start">
            <div ref="liste" class="liste wpts" @mousemove="checkWptpHover" @mouseleave="hoverWptId = -1">
              <div
                class="line-item"
                :id="wpt.id"
                :class="{ hover: hoverWptId == wpt.id }"
                v-for="wpt in missionPlan.wpts"
                :key="wpt.id"
              >
                <div class="heading ml-2" style="display: flex">
                  <template v-if="currentEditWpt.id == wpt.id">
                    <div style="flex: 1 0">
                      <v-text-field
                        :label="$t('Admin.MissionPlanTemplate.Form.Label')"
                        v-model="currentEditWpt.wpt_label"
                      ></v-text-field>
                      <v-layout row>
                        <lat-lng-field
                          :format="coordFormatFilter"
                          :label="$t('Admin.MissionPlanTemplate.Form.Lat')"
                          v-model.number="currentEditWpt.wpt_lat"
                          :isLat="true"
                          class="mr-4"
                        />
                        <lat-lng-field
                          :format="coordFormatFilter"
                          :label="$t('Admin.MissionPlanTemplate.Form.Lng')"
                          v-model.number="currentEditWpt.wpt_lon"
                          :isLat="false"
                          class="ml-4"
                        />
                      </v-layout>
                    </div>
                    <div style="flex: 0 0">
                      <v-btn
                        icon
                        small
                        @click="cancelWaypoint()"
                        :title="$t('Admin.MissionPlanTemplate.Form.CancelTooltip')"
                      >
                        <v-icon>mdi-close-circle</v-icon>
                      </v-btn>
                      <br />
                      <v-btn
                        icon
                        small
                        @click="updateWaypoint()"
                        :title="$t('Admin.MissionPlanTemplate.Form.ValidTooltip')"
                      >
                        <v-icon>mdi-check-circle</v-icon>
                      </v-btn>
                    </div>
                  </template>
                  <template v-else>
                    {{ formatWaypoint(wpt) }}
                    <v-spacer />
                    <v-btn
                      v-if="!readonly"
                      icon
                      small
                      @click="editWaypoint(wpt)"
                      :title="$t('Admin.MissionPlanTemplate.Form.Edit')"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="!readonly"
                      icon
                      small
                      @click="addNewStep(wpt)"
                      :title="$t('Admin.MissionPlanTemplate.Form.AddStepToPoint')"
                    >
                      <v-icon>mdi-playlist-plus</v-icon>
                    </v-btn>
                    <v-btn
                      v-if="!readonly && missionPlan.steps.findIndex(s => s.wpt_id == wpt.id) == -1"
                      icon
                      small
                      @click="deleteWaypoint(wpt)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                </div>
              </div>
            </div>
          </v-layout>
        </v-card-title>
        <v-card-title
          v-else-if="isProfileTabVisible"
          :style="{ height: `calc(100% - ${hasSlotData ? '128' : '64'}px)` }"
          style="flex-direction: column; align-items: stretch"
        >
          <v-layout row wrap style="flex: 1 0; overflow: auto; align-items: flex-start">
            <div class="liste wpts">
              <div
                class="line-item"
                @click.prevent="!readonly && editProfil(prf.id)"
                :id="prf.id"
                v-for="prf in missionPlan.prf_nav"
                :key="prf.id"
              >
                <div class="heading ml-2" style="display: flex">
                  {{ formatProfilNav(prf) }}
                  <v-spacer />
                  <small>{{ displayProfilNav(prf, true) }}</small>
                  <v-btn
                    v-if="
                      !readonly &&
                      missionPlan.steps.findIndex(s => s.prfNav_id == prf.id) == -1 &&
                      currentEditProfil.id != prf.id
                    "
                    icon
                    small
                    @click.stop.prevent="deleteProfil(prf)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn v-if="!readonly" icon small @click.stop.prevent="copyProfil(prf)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                  <v-btn v-if="!readonly" icon small><v-icon>mdi-pencil</v-icon></v-btn>
                </div>
              </div>
            </div>
          </v-layout>
        </v-card-title>
        <v-card-title
          v-else-if="isSensorsTabVisible"
          :style="{ height: `calc(100% - ${hasSlotData ? '128' : '64'}px)` }"
          style="flex-direction: column; align-items: stretch"
        >
          <v-layout row wrap style="flex: 1 0; overflow: auto; align-items: flex-start">
            <div class="liste wpts">
              <div
                class="line-item"
                @click.prevent="editSensor(sensor.id)"
                :id="sensor.id"
                v-for="sensor in missionPlan.payload"
                :key="sensor.id"
              >
                <div class="heading ml-2 flex">
                  <span class="grow">{{ sensor.snr_label }}</span>
                  <v-btn v-if="!readonly" icon small @click.stop.prevent="deleteSensor(sensor)">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn v-if="!readonly" icon small><v-icon>mdi-pencil</v-icon></v-btn>
                </div>
              </div>
            </div>
          </v-layout>
        </v-card-title>
        <v-card-title
          v-else-if="isProfileSciTabVisible"
          :style="{ height: `calc(100% - ${hasSlotData ? '128' : '64'}px)` }"
          style="flex-direction: column; align-items: stretch"
        >
          <v-layout row wrap style="flex: 1 0; overflow: auto; align-items: flex-start">
            <div class="liste wpts">
              <div
                class="line-item"
                @click.prevent="editProfilSci(prf.id)"
                :id="prf.id"
                v-for="prf in missionPlan.prf_sci"
                :key="prf.id"
              >
                <div class="heading ml-2" style="display: flex">
                  {{ formatProfilSci(prf) }}
                  <v-spacer />
                  <small>{{ displayProfilSci(prf, true) }}</small>
                  <v-btn
                    v-if="
                      !readonly &&
                      missionPlan.steps.findIndex(s => s.prfSci_id == prf.id) == -1 &&
                      currentEditProfilSci.id != prf.id
                    "
                    icon
                    small
                    @click.stop.prevent="deleteProfilSci(prf)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                  <v-btn v-if="!readonly" icon small @click.stop.prevent="copyProfilSci(prf)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                  <v-btn v-if="!readonly" icon small><v-icon>mdi-pencil</v-icon></v-btn>
                </div>
              </div>
            </div>
          </v-layout>
        </v-card-title>
        <slot name="action"></slot>
      </v-card>
    </v-flex>
    <v-dialog v-model="showEditProfil" persistent max-width="950" scrollable>
      <v-card>
        <v-toolbar card>
          <v-toolbar-title>
            <div class="d-flex items-center gap-4">
              {{ $t('Admin.MissionPlanTemplate.Form.NavigationProfil') }} :
              <v-text-field
                hide-details
                type="text"
                :label="$t('Admin.MissionPlanTemplate.Form.Label')"
                :hint="$t('Admin.MissionPlanTemplate.Form.LabelTooltip')"
                v-model="currentEditProfil.prf_label"
              />
            </div>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs4 class="inline-block pa-2">
              <number-field-factor
                :label="$t('Admin.MissionPlanTemplate.Form.Bd')"
                :hint="$t('Admin.MissionPlanTemplate.Form.BdTooltip')"
                v-model.number="currentEditProfil.bd"
              />
              <number-field-factor
                :label="$t('Admin.MissionPlanTemplate.Form.Bu')"
                :hint="$t('Admin.MissionPlanTemplate.Form.BuTooltip')"
                v-model.number="currentEditProfil.bu"
              />
              <number-field-factor
                :label="$t('Admin.MissionPlanTemplate.Form.Zs')"
                :hint="$t('Admin.MissionPlanTemplate.Form.ZsTooltip')"
                v-model.number="currentEditProfil.zs"
              />
            </v-flex>
            <v-flex xs4 class="inline-block pa-2">
              <number-field-factor
                :label="$t('Admin.MissionPlanTemplate.Form.Pd')"
                :hint="$t('Admin.MissionPlanTemplate.Form.PdTooltip')"
                v-model.number="currentEditProfil.pd"
              />
              <number-field-factor
                :label="$t('Admin.MissionPlanTemplate.Form.Pu')"
                :hint="$t('Admin.MissionPlanTemplate.Form.PuTooltip')"
                v-model.number="currentEditProfil.pu"
              />
              <number-field-factor
                :label="$t('Admin.MissionPlanTemplate.Form.Zt')"
                :hint="$t('Admin.MissionPlanTemplate.Form.ZtTooltip')"
                v-model.number="currentEditProfil.zt"
              />
            </v-flex>
            <v-flex xs4 class="inline-block pa-2">
              <number-field-factor
                :label="$t('Admin.MissionPlanTemplate.Form.Sr')"
                :hint="$t('Admin.MissionPlanTemplate.Form.SrTooltip')"
                v-model.number="currentEditProfil.sr"
              />
              <number-field-factor
                :label="$t('Admin.MissionPlanTemplate.Form.Alt')"
                :hint="$t('Admin.MissionPlanTemplate.Form.AltTooltip')"
                v-model.number="currentEditProfil.alt"
              />
              <number-field-factor
                :label="$t('Admin.MissionPlanTemplate.Form.Zb')"
                :hint="$t('Admin.MissionPlanTemplate.Form.ZbTooltip')"
                v-model.number="currentEditProfil.zb"
              />
            </v-flex>
          </v-layout>
          <div class="d-flex flew-wrap items-center">
            <v-switch
              v-if="enableAdvencedNav"
              hide-details
              v-model="currentEditProfil.radio"
              :label="$t('Simulation.Radio')"
            ></v-switch>
            <v-switch
              v-if="enableAdvencedNav"
              hide-details
              v-model="currentEditProfil.flasher"
              :label="$t('Simulation.Flasher')"
            ></v-switch>
            <v-switch
              v-if="enableAdvencedNav"
              hide-details
              v-model="currentEditProfil.current_correction"
              :label="$t('Simulation.CurrentCorrection')"
            ></v-switch>
            <div v-if="enableAdvencedNav" class="d-flex items-center gap-2">
              <span class="!grow-0">{{ $t('Simulation.NavigationMode') }}:</span>
              <v-radio-group hide-details class="pa-0 ma-0" :column="false" v-model="currentEditProfil.navigation_mode">
                <v-radio hide-details value="heading" :label="$t('Pilot.MissionPlan.Heading')" />
                <v-radio hide-details value="waypoint" :label="$t('Pilot.MissionPlan.Waypoint')" />
              </v-radio-group>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancelProfil()" small>{{ $t('Admin.MissionPlanTemplate.Form.Cancel') }}</v-btn>
          <v-btn @click="updateProfil()" small color="primary">{{ $t('Admin.MissionPlanTemplate.Form.Valid') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showEditProfilSci" max-width="950" scrollable persistent>
      <v-card>
        <v-toolbar card>
          <v-toolbar-title>
            <div class="d-flex items-center gap-4">
              {{ $t('Admin.MissionPlanTemplate.Form.ScienceProfil') }} :
              <v-text-field
                hide-details
                type="text"
                :label="$t('Admin.MissionPlanTemplate.Form.Label')"
                :hint="$t('Admin.MissionPlanTemplate.Form.LabelTooltip')"
                v-model="currentEditProfilSci.prf_label"
              />
            </div>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="inline-block">
              <h4>{{ $t('Admin.MissionPlanTemplate.Form.Sensors') }}</h4>
              <div class="flex items-center py-1 gap-4 sensor-row" v-for="sensor in missionPlan.payload">
                <div style="min-width: 100px">{{ sensor.snr_label }} :</div>
                <EditProfilSciRow
                  v-if="currentEditProfilSci.sensors && currentEditProfilSci.sensors[sensor.id]"
                  v-model="currentEditProfilSci.sensors[sensor.id]"
                />
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancelProfilSci()" small>{{ $t('Admin.MissionPlanTemplate.Form.Cancel') }}</v-btn>
          <v-btn @click="updateProfilSci()" small color="primary">
            {{ $t('Admin.MissionPlanTemplate.Form.Valid') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showEditSensor" max-width="950" scrollable persistent>
      <v-card>
        <v-toolbar card>
          <v-toolbar-title>
            {{ $t('Admin.MissionPlanTemplate.Form.Sensor') }} : {{ currentEditSensor.snr_label }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 class="inline-block pa-2">
              <v-select
                v-model="currentEditSensor.snr_label"
                :items="umbTypes"
                item-text="UMT_KEY"
                item-value="UMT_KEY"
                :label="$t('Admin.MissionPlanTemplate.Form.Sensor')"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="cancelSensor()" small>{{ $t('Admin.MissionPlanTemplate.Form.Cancel') }}</v-btn>
          <v-btn @click="updateSensor()" small color="primary">{{ $t('Admin.MissionPlanTemplate.Form.Valid') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <admin-mission-plan-global-wpt-dialog :uiid="uiid" @addWaypoint="addWaypoint" v-model="showGlobalWpts" />
    <admin-mission-plan-global-wpt-dialog @addWaypoint="addWaypoint" v-model="showGlobalWpts" />
  </v-layout>
</template>

<script lang="ts">
import Vue from 'vue'
//@ts-ignore
import draggable from 'vuedraggable'
import * as extent from 'ol/extent'
import * as proj from 'ol/proj'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import { IMissionPlanWaypoint } from '../../../models/iris/missionPlan/IMissionPlanWaypoint'
import { toNumberDictionary } from '../../../utils/groupBy'
import { IMissionPlanProfilNav } from '../../../models/iris/missionPlan/IMissionPlanProfilNav'
import { IMissionSensor } from '../../../models/iris/missionPlan/IMissionSensor'
import { IMissionPlanStep } from '../../../models/iris/missionPlan/IMissionPlanStep'
import MapControl from '@/components/map/MapControl.vue'
import { MissionPlanUiState } from '../../../models/ui/MissionPlanUiState'
import { Coordinate } from 'ol/coordinate'
import MissionMap from '@/components/map/MissionMap.vue'
import MapMissionPlanContextMenu from '@/components/map/MapMissionPlanContextMenu.vue'
import MapToolList from '@/components/map/MapToolList.vue'
import EditProfilSciRow from '@/components/admin/missionPlanTemplate/EditProfilSciRow.vue'
import { MeasureToolType } from '@/enum/MeasureToolType'
import { IMissionPlanProfilSci } from '@/models/iris/missionPlan/IMissionPlanProfilSci'
import distance from '@turf/distance'
import { point } from '@turf/helpers'
import AdminMissionPlanGlobalWptDialog from '@/components/admin/missionPlanTemplate/AdminMissionPlanGlobalWptDialog.vue'

@Component({
  name: 'AdminMissionPlan',
  components: {
    draggable,
    MapControl,
    MissionMap,
    MapMissionPlanContextMenu,
    MapToolList,
    EditProfilSciRow,
    AdminMissionPlanGlobalWptDialog,
  },
  props: {
    uiid: {
      type: String,
    },
    enablePayload: {
      type: Boolean,
      default: false,
    },
    enableAdvencedNav: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    hideAutoScale: {
      type: Boolean,
      default: false,
    },
  },
})
export default class AdminMissionPlan extends Vue {
  //Mission plan data
  uiid!: string
  enablePayload!: boolean
  enableAdvencedNav!: boolean
  readonly!: boolean
  hideAutoScale!: boolean

  get coordFormatFilter() {
    return this.$store.myGetters.coordFormatFilter
  }

  get missionPlanUiState() {
    return this.$store.myGetters.missionPlanUiStateByUiid(this.uiid)
  }

  get showGlobalWpts() {
    return this.missionPlanUiState.showGlobalWpts
  }
  set showGlobalWpts(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_SHOW_GLOBALWPT({ uiid: this.uiid, show: value })
  }

  get umbTypes() {
    return this.$store.myGetters.umbTypes
  }

  get missionPlan() {
    return this.missionPlanUiState.missionPlan
  }
  set missionPlan(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_MISSIONPLAN({ uiid: this.uiid, plan: value })
  }

  get hoverWptId() {
    return this.missionPlanUiState.hoverWptId
  }
  set hoverWptId(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_HOVER_WPT_ID({ uiid: this.uiid, wptId: value })
  }

  //hoverStepId = -1

  get hoverStepId() {
    return this.missionPlanUiState.hoverStepId
  }
  set hoverStepId(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_HOVER_STEP_ID({ uiid: this.uiid, stepId: value })
  }

  get hoverPrfId() {
    return this.missionPlanUiState.hoverPrfId
  }
  set hoverPrfId(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_HOVER_PRF_ID({ uiid: this.uiid, prfId: value })
  }

  get currentEditProfil() {
    return this.missionPlanUiState.currentEditProfil
  }
  set currentEditProfil(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_CURRENT_EDIT_PROFIL({ uiid: this.uiid, prf: value })
  }

  get currentEditProfilSci() {
    return this.missionPlanUiState.currentEditProfilSci
  }
  set currentEditProfilSci(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_CURRENT_EDIT_PROFIL_SCI({ uiid: this.uiid, prf: value })
  }

  get currentEditStep() {
    return this.missionPlanUiState.currentEditStep
  }
  set currentEditStep(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_CURRENT_EDIT_STEP({ uiid: this.uiid, step: value })
  }

  get currentEditWpt() {
    return this.missionPlanUiState.currentEditWpt
  }
  set currentEditWpt(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_CURRENT_EDIT_WPT({ uiid: this.uiid, wpt: value })
  }

  get currentEditSensor() {
    return this.missionPlanUiState.currentEditSensor
  }
  set currentEditSensor(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_CURRENT_EDIT_SENSOR({ uiid: this.uiid, sensor: value })
  }

  get drawMode() {
    return this.missionPlanUiState.drawMode
  }
  set drawMode(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_DRAWMOD({ uiid: this.uiid, drawmode: value })
  }

  get lastActionId() {
    return this.missionPlanUiState.lastActionId
  }
  set lastActionId(value) {
    this.$store.myActions.UI_MISSIONPLAN_SET_LASTACTION_ID({ uiid: this.uiid, actId: value })
  }

  visibleTab = 'steps' //steps || waypoints || profiles
  get isStepTabVisible() {
    return this.visibleTab == 'steps'
  }

  get distanceTotal() {
    let dist: number = 0
    if (this.missionPlan.steps.length > 0) {
      this.missionPlan.steps.forEach((step, index) => {
        if (index > 0) {
          dist +=
            distance(
              point([
                this.wptsById[this.missionPlan.steps[index - 1].wpt_id].wpt_lon,
                this.wptsById[this.missionPlan.steps[index - 1].wpt_id].wpt_lat,
              ]),
              point([
                this.wptsById[this.missionPlan.steps[index].wpt_id].wpt_lon,
                this.wptsById[this.missionPlan.steps[index].wpt_id].wpt_lat,
              ]),
            ) * 1000
        }
      })
    }
    return this.$options.filters?.formatDistance(dist.toFixed(0))
  }

  //Corrige le bug du blocage
  get refreshMesureTool() {
    return this.$store.myGetters.refreshMesureTool
  }
  @Watch('refreshMesureTool')
  onRefreshMesureTool(newValue: boolean) {
    this.drawMode = ''
  }

  get measureTool() {
    return this.$store.myGetters.measureTool
  }
  @Watch('measureTool')
  onMeasureToolChange(newValue: string) {
    if (newValue == MeasureToolType.NONE) {
      this.currentMeasureFeature = null
      this.measureText = null
      this.measuresFeatures = []
    } else {
      //désactive l'edition ou l'ajout de waypoint et de step...
      this.$nextTick(() => {
        if (this.drawMode != '') {
          this.updateWaypoint()
          this.drawMode = ''
        }
      })
    }
  }
  get drawType() {
    return this.$store.myGetters.drawType
  }
  measureCoord: Coordinate = [0, 0]
  hoverProfil = ''
  measureText: string | null = ''
  measuresFeatures = []
  currentMeasureFeature: any = null
  measureListener: any = null

  showStepTab() {
    this.visibleTab = 'steps'
  }

  get hasSlotData() {
    return this.$slots.default || this.$slots.action
  }

  get isWaipointTabVisible() {
    return this.visibleTab == 'waypoints'
  }
  showWaipointTab() {
    this.visibleTab = 'waypoints'
  }

  get isProfileTabVisible() {
    return this.visibleTab == 'profiles'
  }
  showProfileTab() {
    this.visibleTab = 'profiles'
  }

  get isProfileSciTabVisible() {
    return this.visibleTab == 'profilessci'
  }
  showProfileSciTab() {
    this.visibleTab = 'profilessci'
  }

  get isSensorsTabVisible() {
    return this.visibleTab == 'sensors'
  }
  showSensorsTab() {
    this.visibleTab = 'sensors'
  }

  @Watch('enablePayload')
  onEnablePayloadChanged() {
    if (!this.enablePayload && (this.isProfileSciTabVisible || this.isSensorsTabVisible)) {
      this.showProfileTab()
    }
  }

  //Popup map variables
  menuXpos = 0
  menuYpos = 0
  showMenu = false

  //Global waypoints array
  get globalWpts() {
    return this.$store.myGetters.positionRemarquables.map(p => {
      return { id: p.id, wpt_label: p.prmLibelle, wpt_lat: p.gpsLat, wpt_lon: p.gpsLon }
    })
  }

  addWaypoint({ wpt, edit }: { wpt: IMissionPlanWaypoint; edit: boolean }) {
    if (edit) {
      wpt.wpt_lat =
        this.missionPlanUiState.missionPlan.wpts.length == 0
          ? 0
          : this.missionPlanUiState.missionPlan.wpts.reduce((acc, value) => {
              return acc + value.wpt_lat
            }, 0) / this.missionPlanUiState.missionPlan.wpts.length
      wpt.wpt_lon =
        this.missionPlanUiState.missionPlan.wpts.length == 0
          ? 0
          : this.missionPlanUiState.missionPlan.wpts.reduce((acc, value) => {
              return acc + value.wpt_lon
            }, 0) / this.missionPlanUiState.missionPlan.wpts.length
    }
    const newWpt = { ...wpt, id: this.nextWptsId() } as IMissionPlanWaypoint
    this.missionPlanUiState.missionPlan.wpts.push(newWpt)
    if (edit) {
      //on edit le waypoint en direct
      this.$store.myActions.UI_MISSIONPLAN_SET_CURRENT_EDIT_WPT({
        uiid: this.uiid,
        wpt: JSON.parse(JSON.stringify(newWpt)),
      })
    }
  }

  reset() {
    this.$nextTick(() => {
      this.hoverWptId = -1
      this.hoverStepId = -1
      this.hoverPrfId = -1
      //current editing profil
      this.currentEditProfil = MissionPlanUiState.getDefaultProfil()
      //current editing step
      this.currentEditStep = MissionPlanUiState.getDefaultStep()
      //current editing wpts
      this.currentEditWpt = MissionPlanUiState.getDefaultWayPoint()
      //current editing sensor
      this.currentEditSensor = MissionPlanUiState.getDefaultSensor()
      //mode d'ajout de point step or wpt
      this.drawMode = ''
      this.lastActionId =
        this.missionPlan.steps && this.missionPlan.steps.length > 0
          ? this.missionPlan.steps[this.missionPlan.steps.length - 1].nextStep_id!
          : -1
      //remet à -1 mouillage virtuel si besoin
      if (this.lastActionId != -1 && this.lastActionId == this.missionPlan.steps[this.missionPlan.steps.length - 1].id)
        this.lastActionId = -1
    })
  }

  get steps() {
    const wpt = this.wptsById[this.missionPlan.steps[0].wpt_id]
    let prev = [wpt.wpt_lon - 0.01, wpt.wpt_lat - 0.01]

    return this.missionPlan.steps.map(s => {
      const wpt = this.wptsById[s.wpt_id]
      const path = [prev, [wpt.wpt_lon, wpt.wpt_lat]]
      prev = [wpt.wpt_lon, wpt.wpt_lat]
      return path
    })
  }

  get lastactions() {
    return [
      {
        label: this.$t('Admin.MissionPlanTemplate.Form.VirtualMooring'),
        value: -1,
      },
      ...this.missionPlan.steps.map((s, index) => {
        return {
          label: `Execute step ${index + 1} - Go to ${this.formatWaypoint(this.wptsById[s.wpt_id])}`,
          value: s.id,
        }
      }),
    ]
  }

  get lastPath() {
    if (this.missionPlan.steps && this.missionPlan.steps.length > 0 && this.lastActionId != -1) {
      const lastWpt = this.wptsById[this.missionPlan.steps[this.missionPlan.steps.length - 1].wpt_id]
      const newStartWpt = this.wptsById[this.stepsById[this.lastActionId].wpt_id]
      //console.log([[lastWpt.wpt_lon,lastWpt.wpt_lat],[newStartWpt.wpt_lon,newStartWpt.wpt_lat]])
      return [
        [lastWpt.wpt_lon, lastWpt.wpt_lat],
        [newStartWpt.wpt_lon, newStartWpt.wpt_lat],
      ]
    }
    return []
  }

  get stepItems() {
    return this.missionPlan.steps.map((s, index) => {
      return {
        label: `Step ${index + 1}`,
        value: s.id,
      }
    })
  }

  get showEditProfil() {
    return this.currentEditProfil?.id
  }
  set showEditProfil(value) {
    if (!value) this.cancelProfil()
  }

  get showEditProfilSci() {
    return this.currentEditProfilSci?.id
  }
  set showEditProfilSci(value) {
    if (!value) this.cancelProfilSci()
  }

  get showEditSensor() {
    return this.currentEditSensor?.id
  }
  set showEditSensor(value) {
    if (!value) this.cancelSensor()
  }

  get wptsById() {
    return toNumberDictionary(this.missionPlan.wpts ?? [], it => it.id)
  }
  get stepsById() {
    return toNumberDictionary(this.missionPlan.steps ?? [], it => it.id)
  }
  get prf_navById() {
    return toNumberDictionary(this.missionPlan.prf_nav ?? [], it => it.id)
  }
  get sensorById() {
    return toNumberDictionary(this.missionPlan.payload ?? [], it => it.id)
  }
  get prf_sciById() {
    return toNumberDictionary(this.missionPlan.prf_sci ?? [], it => it.id)
  }

  checkStepHover(event: any) {
    if (!event.target) return
    const item = event.target.closest('.line-item')

    if (item) this.hoverStepId = parseInt(item.id)
    else this.hoverStepId = -1
  }

  checkWptpHover(event: any) {
    if (!event.target) return
    const item = event.target.closest('.line-item')

    if (item) this.hoverWptId = parseInt(item.id)
    else this.hoverWptId = -1
  }

  checkPrfHover(event: any) {
    if (!event.target) return
    const item = event.target.closest('.line-item')

    if (item) this.hoverPrfId = parseInt(item.id)
    else this.hoverPrfId = -1
  }

  bestFit() {
    if (this.missionPlan?.wpts?.length) {
      const ext = extent.boundingExtent(
        this.missionPlan.wpts
          .filter(wpt => wpt.wpt_lon != null && wpt.wpt_lat != null)
          .map(wpt => [wpt.wpt_lon, wpt.wpt_lat] as [number, number]),
      )
      if (ext[0] == ext[2] && ext[1] == ext[3]) {
        this.$emit('goto', extent.getCenter(ext))
      } else {
        const ext3857 = proj.transformExtent(ext, proj.get('EPSG:4326')!, proj.get('EPSG:3857')!)
        this.$emit('fit', ext3857)
      }
    }
  }

  editStep(id: number) {
    this.currentEditStep = JSON.parse(JSON.stringify(this.stepsById[id])) as IMissionPlanStep
    this.currentEditProfil = JSON.parse(
      JSON.stringify(this.prf_navById[this.currentEditStep.prfNav_id]),
    ) as IMissionPlanProfilNav
  }

  editSensor(id: number) {
    //on edit seulement si le profil n'est pas deja selectionné
    if (this.currentEditSensor.id != id) {
      if (id == -1) {
        this.currentEditSensor = { ...MissionPlanUiState.getDefaultSensor(), id: -1 } as IMissionSensor
      } else {
        this.currentEditSensor = JSON.parse(JSON.stringify(this.sensorById[id])) as IMissionSensor
      }
    }
  }

  updateSensor() {
    if (this.currentEditSensor.id == -1) {
      //donne un vrai id au profil
      this.currentEditSensor.id = this.nextSensorId()
      //ajoute le profil a la liste des profils
      this.missionPlan.payload.push(this.currentEditSensor)

      this.missionPlan.prf_sci.forEach(p => {
        p.sensors[this.currentEditSensor.id] = [1, '111', 1]
      })
    } else {
      const sensor = this.sensorById[this.currentEditSensor.id]
      if (sensor) {
        Object.keys(sensor).forEach(key => {
          //@ts-ignore
          if (key != 'id') sensor[key] = this.currentEditSensor[key]
        })
      }
    }

    this.cancelSensor()
  }

  cancelSensor() {
    this.currentEditSensor = {} as IMissionSensor
  }

  editProfil(id: number) {
    //on edit seulement si le profil n'est pas deja selectionné
    if (this.currentEditProfil.id != id) {
      if (id == -1) {
        this.currentEditProfil = { ...MissionPlanUiState.getDefaultProfil(), id: -1 } as IMissionPlanProfilNav
      } else {
        this.currentEditProfil = JSON.parse(JSON.stringify(this.prf_navById[id])) as IMissionPlanProfilNav
      }
    }
  }

  copyProfil(prf: IMissionPlanProfilNav) {
    this.currentEditProfil = {
      ...prf,
      prf_label: `Copy of ${this.formatProfilNav(prf)}`,
      id: -1,
    } as IMissionPlanProfilNav
  }

  updateProfil() {
    if (this.currentEditProfil.id == -1) {
      //donne un vrai id au profil
      this.currentEditProfil.id = this.nextProfilId()
      //ajoute le profil a la liste des profils
      this.missionPlan.prf_nav.push(this.currentEditProfil)
    } else {
      const profil = this.prf_navById[this.currentEditProfil.id]
      if (profil) {
        Object.keys(profil).forEach(key => {
          //@ts-ignore
          if (key != 'id') profil[key] = this.currentEditProfil[key]
        })
      }
    }

    this.cancelProfil()
  }

  cancelProfil() {
    this.currentEditProfil = {} as IMissionPlanProfilNav
  }

  editProfilSci(id: number) {
    //on edit seulement si le profil n'est pas deja selectionné
    if (this.currentEditProfilSci.id != id) {
      if (id == -1) {
        this.currentEditProfilSci = {
          ...MissionPlanUiState.getDefaultProfilSci(),
          id: -1,
          sensors: this.missionPlan.payload.reduce((s, it) => {
            s[it.id] = [1, '111', 1]
            return s
          }, {} as { [key: number]: Array<number | string> }),
        } as IMissionPlanProfilSci
      } else {
        this.currentEditProfilSci = JSON.parse(JSON.stringify(this.prf_sciById[id])) as IMissionPlanProfilSci
      }
    }
  }

  copyProfilSci(prf: IMissionPlanProfilSci) {
    this.currentEditProfilSci = {
      ...prf,
      prf_label: `Copy of ${this.formatProfilSci(prf)}`,
      id: -1,
    } as IMissionPlanProfilSci
  }

  updateProfilSci() {
    if (this.currentEditProfilSci.id == -1) {
      //donne un vrai id au profil
      this.currentEditProfilSci.id = this.nextProfilSciId()
      //ajoute le profil a la liste des profils
      this.missionPlan.prf_sci.push(this.currentEditProfilSci)
    } else {
      const profil = this.prf_sciById[this.currentEditProfilSci.id]
      if (profil) {
        Object.keys(profil).forEach(key => {
          //@ts-ignore
          if (key != 'id') profil[key] = this.currentEditProfilSci[key]
        })
      }
    }

    this.cancelProfilSci()
  }

  cancelProfilSci() {
    this.currentEditProfilSci = {} as IMissionPlanProfilSci
  }

  editWaypoint(wpt: IMissionPlanWaypoint) {
    this.$store.myActions.UI_SET_MEASURETOOL('NONE')
    if (this.drawMode != '') this.drawMode = ''
    this.$nextTick(() => {
      this.updateWaypoint()
      this.currentEditWpt = JSON.parse(JSON.stringify(wpt))
    })
  }

  updateWaypoint() {
    const wpt = this.wptsById[this.currentEditWpt.id]
    if (wpt) {
      Object.keys(this.currentEditWpt).forEach(key => {
        //@ts-ignore
        if (key == 'wpt_lat' || key == 'wpt_lon') wpt[key] = parseFloat(this.currentEditWpt[key])
        //@ts-ignore
        else if (key != 'id') wpt[key] = this.currentEditWpt[key]
      })
    }
    this.cancelWaypoint()
  }

  cancelWaypoint() {
    this.currentEditWpt = MissionPlanUiState.getDefaultWayPoint()
    this.hoverWptId = -1
  }

  updateConfig() {
    //met à jour le chainage des items des steps
    this.updateNextStep()
  }

  updateNextStep(stop: number = -1) {
    if (stop == -1) stop = this.missionPlan.steps.length
    this.missionPlan.steps.forEach((step, index) => {
      step.prfSci_id = step.prfSci_id ?? -1
      step.prfNav_id = step.prfNav_id ?? -1

      if (index > stop) return
      if (index < this.missionPlan.steps.length - 1) {
        step.nextStep_id = this.missionPlan.steps[index + 1].id
      } else {
        step.nextStep_id = step.id
      }
    })
    //affecte la derniere actions
    if (this.missionPlan.steps.length > 0)
      this.missionPlan.steps[this.missionPlan.steps.length - 1].nextStep_id =
        this.lastActionId == -1 ? this.missionPlan.steps[this.missionPlan.steps.length - 1].id : this.lastActionId
  }

  nextWptsId() {
    return (this.missionPlan?.wpts?.length ?? 0) > 0 ? Math.max(...this.missionPlan.wpts.map(i => i.id)) + 1 : 1
  }

  nextSensorId() {
    return (this.missionPlan?.payload?.length ?? 0) > 0 ? Math.max(...this.missionPlan.payload.map(i => i.id)) + 1 : 1
  }

  nextProfilId() {
    return (this.missionPlan?.prf_nav?.length ?? 0) > 0 ? Math.max(...this.missionPlan.prf_nav.map(i => i.id)) + 1 : 1
  }

  nextProfilSciId() {
    return (this.missionPlan?.prf_sci?.length ?? 0) > 0 ? Math.max(...this.missionPlan.prf_sci.map(i => i.id)) + 1 : 1
  }

  nextStepId() {
    return (this.missionPlan?.steps?.length ?? 0) > 0 ? Math.max(...this.missionPlan.steps.map(i => i.id)) + 1 : 1
  }

  addNewStep(wpt: IMissionPlanWaypoint) {
    //aucun profil n'existe on en crée un
    if (this.missionPlan.prf_nav.length == 0)
      this.missionPlan.prf_nav.push({ ...MissionPlanUiState.getDefaultProfil(), id: this.nextProfilId() })
    const lastProfil =
      this.missionPlan.steps.length > 0
        ? this.prf_navById[this.missionPlan.steps[this.missionPlan.steps.length - 1].prfNav_id]
        : (this.missionPlan.prf_nav[this.missionPlan.prf_nav.length - 1] as IMissionPlanProfilNav)

    //aucun profil sci n'existe on en crée un
    if (this.missionPlan.prf_sci.length == 0)
      this.missionPlan.prf_sci.push({
        ...MissionPlanUiState.getDefaultProfilSci(),
        id: this.nextProfilSciId(),
        prf_label: 'All on',
        sensors: this.missionPlan.payload.reduce((s, it) => {
          s[it.id] = [1, '111', 1]
          return s
        }, {} as { [key: number]: [number, string, number] }),
      })
    const lastProfilSci =
      this.missionPlan.steps.length > 0
        ? this.prf_sciById[this.missionPlan.steps[this.missionPlan.steps.length - 1].prfSci_id]
        : (this.missionPlan.prf_sci[this.missionPlan.prf_sci.length - 1] as IMissionPlanProfilSci)

    const lastStep =
      this.missionPlan.steps.length > 0
        ? this.missionPlan.steps[this.missionPlan.steps.length - 1]
        : (MissionPlanUiState.getDefaultStep() as IMissionPlanStep)
    const newStep = {
      ...lastStep,
      wpt_id: wpt.id,
      id: this.nextStepId(),
      prfNav_id: lastProfil?.id,
      prfSci_id: lastProfilSci?.id,
    } as IMissionPlanStep

    this.missionPlan.steps.push(newStep)
    this.updateNextStep()
  }

  deleteStep(step: IMissionPlanStep) {
    this.$confirm(this.$t('Admin.MissionPlanTemplate.Form.ConfirmDeleteStepMessage').toString()).then(remove => {
      if (remove) {
        if (step.id == this.missionPlan.cur_step) this.missionPlan.cur_step = -1
        //supprime le step
        this.missionPlan.steps.splice(
          this.missionPlan.steps.findIndex(it => it.id == step.id),
          1,
        )
        this.updateNextStep()
      }
    })
  }

  deleteWaypoint(wpt: IMissionPlanWaypoint) {
    this.$confirm(this.$t('Admin.MissionPlanTemplate.Form.ConfirmDeleteWaypointMessage').toString()).then(remove => {
      if (remove && this.missionPlan.steps.findIndex(s => s.wpt_id == wpt.id) == -1) {
        //supprime le waypoint
        this.missionPlan.wpts.splice(
          this.missionPlan.wpts.findIndex(it => it.id == wpt.id),
          1,
        )
      }
    })
  }

  deleteProfil(prf: IMissionPlanProfilNav) {
    this.$confirm(this.$t('Admin.MissionPlanTemplate.Form.ConfirmDeleteProfilMessage').toString()).then(remove => {
      if (remove && this.missionPlan.steps.findIndex(s => s.prfNav_id == prf.id) == -1) {
        //supprime le profil
        this.missionPlan.prf_nav.splice(
          this.missionPlan.prf_nav.findIndex(it => it.id == prf.id),
          1,
        )
      }
    })
  }

  deleteProfilSci(prf: IMissionPlanProfilSci) {
    this.$confirm(this.$t('Admin.MissionPlanTemplate.Form.ConfirmDeleteProfilSciMessage').toString()).then(remove => {
      if (remove && this.missionPlan.steps.findIndex(s => s.prfSci_id == prf.id) == -1) {
        //supprime le science profil
        this.missionPlan.prf_sci.splice(
          this.missionPlan.prf_sci.findIndex(it => it.id == prf.id),
          1,
        )
      }
    })
  }

  deleteSensor(sensor: IMissionSensor) {
    this.$confirm(this.$t('Admin.MissionPlanTemplate.Form.ConfirmDeleteSensorMessage').toString()).then(remove => {
      if (remove) {
        //supprime le science profil
        this.missionPlan.payload.splice(
          this.missionPlan.payload.findIndex(it => it.id == sensor.id),
          1,
        )

        this.missionPlan.prf_sci.forEach(p => {
          delete p.sensors[sensor.id]
        })
      }
    })
  }

  formatWaypoint(wpt: IMissionPlanWaypoint) {
    return wpt.wpt_label && wpt.wpt_label.length > 0 ? wpt.wpt_label : this.toCoordString(wpt)
  }

  formatProfilNav(prf: IMissionPlanProfilNav) {
    if (prf.id == -1) return this.$t('Admin.MissionPlanTemplate.Form.NewProfil').toString()
    return prf.prf_label && prf.prf_label.length > 0 ? prf.prf_label : `Profil ${prf.id}`
  }

  formatProfilSci(prf: IMissionPlanProfilSci) {
    if (prf.id == -1) return this.$t('Admin.MissionPlanTemplate.Form.NewProfilSci').toString()
    return prf.prf_label && prf.prf_label.length > 0 ? prf.prf_label : `Profil sci ${prf.id}`
  }

  displayProfilNav(prf: IMissionPlanProfilNav, hideLabel: boolean = false) {
    if (!prf) return ''
    return `${hideLabel ? '' : this.formatProfilNav(prf)}  ( bd:${prf.bd}, bu:${prf.bu}, pd:${prf.pd}, pu:${
      prf.pu
    }, sr:${prf.sr}, zb:${prf.zb}, zt:${prf.zt}, alt:${prf.alt})`
  }

  displayProfilSci(prf: IMissionPlanProfilSci, hideLabel: boolean = false) {
    if (!prf) return ''
    //@ts-ignore
    const sensors =
      Object.keys(prf.sensors ?? [])
        .map(key => {
          const label = this.sensorById[parseInt(key)]?.snr_label
          const config = prf.sensors[parseInt(key)] ?? [1, '111', 1]
          //@ts-ignore
          const sensorPhase = (config?.at(1) ?? '111').toString().padStart(3, '0')
          return {
            label,
            //@ts-ignore
            enable: (config?.at(0) ?? 1) != 0,
            //@ts-ignore
            descEnable: sensorPhase?.at(0) != '0',
            //@ts-ignore
            otherEnable: sensorPhase?.at(1) != '0',
            //@ts-ignore
            ascEnable: sensorPhase?.at(2) != '0',
            //@ts-ignore
            periode: config?.at(2) ?? 1,
          }
        })
        .filter(it => it.enable)
        .map(
          it =>
            `${it?.label} ${it.descEnable ? '↓' : ''}${it.otherEnable ? '⥴' : ''}${it.ascEnable ? '↑' : ''} ${
              it.periode
            }s`,
        )
        .join(', ') ?? ''
    return `${hideLabel ? '' : this.formatProfilSci(prf)}  ${sensors.length > 0 ? `(${sensors})` : ''}`
  }

  toCoordString(wpt: IMissionPlanWaypoint) {
    //@ts-ignore
    return this.$options.filters[this.$store.myGetters.coordFormatFilter]([wpt.wpt_lon, wpt.wpt_lat])
  }

  showGlobalWaypoint() {
    this.$store.myActions.UI_MISSIONPLAN_SET_SHOW_GLOBALWPT({ uiid: this.uiid, show: true })
  }

  beforeDestroy() {
    this.hoverWptId = -1
    this.hoverStepId = -1
    this.hoverPrfId = -1
    //current editing profil
    this.currentEditProfil = MissionPlanUiState.getDefaultProfil()
    //current editing step
    this.currentEditStep = MissionPlanUiState.getDefaultStep()
    //current editing wpts
    this.currentEditWpt = MissionPlanUiState.getDefaultWayPoint()
    //mode d'ajout de point step or wpt
    this.drawMode = ''
  }

  /*Cycle de vie*/
  created() {
    this.$store.myActions.UMBTYPE_ENSURE_LIST()
    this.$store.myActions.UI_ENSURE_MAP_STATE('MissionPlan')
    this.$store.myActions.POSITIONREMARQUABLE_ENSURE_LIST()
  }

  mounted() {
    setTimeout(() => this.reset(), 400)
  }

  onMove(event: any) {
    this.updateNextStep(Math.max(event.moved.newIndex, event.moved.oldIndex))
  }

  get canCloseWithoutWarning() {
    let canClose = true
    if (this.stepItems.length > 0 && this.stepItems.findIndex(s => s.value == this.missionPlan.cur_step) < 0) {
      canClose = false
    }
    return canClose
  }
}
</script>
<style scoped>
.sensor-row {
  border-bottom: 1px solid #999;
}
</style>
<style>
.rights .v-table__overflow,
.rights .v-datatable {
  overflow-x: hidden;
}
.ghost {
  color: var(--primary-color);
}

.steps .line-item:hover,
.wpts .line-item:hover,
.steps .line-item.hover,
.wpts .line-item.hover {
  background-color: #eee;
}

.steps .line-item.current,
.steps .line-item.current:hover {
  background-color: darkseagreen;
  font-weight: bold;
}

.steps .line-item.selected,
.wpts .line-item.selected {
  background-color: var(--primary-color);
  color: #fff;
}

.tooltip-map:hover,
.tooltip-map.hover {
  background-color: var(--primary-color);
  color: #fff;
  font-size: 12px;
}

.tooltip-map.hover:before {
  border-top-color: var(--primary-color);
}

.tooltip-map {
  position: relative;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 4px;
  color: #000000;
  padding: 4px 8px;
  white-space: nowrap;
  font-size: 10px;
}

.tooltip-map:before {
  border-top: 6px solid rgba(255, 255, 255, 0.5);
  border-right: 6px solid transparent;
  border-left: 6px solid transparent;
  content: '';
  position: absolute;
  bottom: -6px;
  margin-left: -7px;
  left: 50%;
}

.tabnav .theme--light.v-btn.v-btn--disabled .v-icon {
  color: var(--primary-color) !important;
}
.selectedTab {
  color: var(--primary-color);
}

.profilInfos {
  font-style: italic;
  font-size: 11px;
}

.backStep {
  background-color: #ba99d8;
}
</style>
